module.exports = __webpack_public_path__ + "img/video-conference.903bcbdf.svg";